import { useEffect, useState } from 'react';
import ErrorPage from './shared/error-page';
import {
  createBrowserRouter,
  redirect,
  RouterProvider,
} from 'react-router-dom';
import { CssBaseline, Theme, ThemeProvider } from '@mui/material';
import { useLocalization } from './providers/localization-provider/localization-context';
import { IntlProvider } from 'react-intl';
import {
  fetchI18nMessages,
  i18nMessageList,
} from './providers/localization-provider/localization-utils';
import { THEME } from './utils/theme';
import Home from './routes/home/home';
import Layout from './shared/layout/layout';

declare module '@mui/styles/defaultTheme' {
  interface DefaultTheme extends Theme {}
}

// note: if Auth is to be used, refer to this implementation in BrainOS Hub
const router = createBrowserRouter([
  {
    // Main Page and its children
    path: '/',
    element: <Layout />,
    errorElement: <ErrorPage />,
    children: [{ path: '/', element: <Home /> }],
  },
  {
    path: '*',
    element: null,
    errorElement: <ErrorPage />,
    loader: () => {
      return redirect('/');
    },
  },
]);

const App = () => {
  const [translationMessages, setTranslationMessages] =
    useState<i18nMessageList>();
  const [{ locale }] = useLocalization();

  useEffect(() => {
    const applyTranslations = async () => {
      const messages = await fetchI18nMessages(locale.value);
      setTranslationMessages(messages);
    };
    applyTranslations();
  }, [locale]);

  return (
    <ThemeProvider theme={THEME}>
      <CssBaseline />
      <IntlProvider locale={locale.value} messages={translationMessages}>
        <RouterProvider router={router} />
      </IntlProvider>
    </ThemeProvider>
  );
};

export default App;
